<template>
    <div class="m_header">
        <div class="banner">
          <img src="../img/mobile/m_logo_white.png" alt="" class="logo">
          <span class="title">
            {{ $t('message.live') }}
          </span>
        </div>
    </div>
</template>

<script>
export default {
    name: 'm_header',
    data: function () {
        return {
            
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.m_header {
  width: 100%;
  .banner {
    width: 100%;
    height: 1rem;
    background-image: url(../img/mobile/m_top_bg.png);
    background-size: cover;
    .logo {
      height: 0.5rem;
      margin: 0.25rem;
    }
    .title {
      color: #fff;
      vertical-align: top;
      line-height: 1rem;
      font-size: 0.42rem;
    }
  }
}
</style>
